import { Button, Card } from "react-bootstrap"
import { Link } from "react-router-dom"
import { BuildingAmenityType } from "../../../Types/buildingAmenityTypes"
import { useState } from "react"
import canAccess from "../../../services/accessService/accessService"
import useAmenityRefs from "../../../Hooks/UseAmenities/useAmenityRefsHook"
import useBuildingRefs from "../../../Hooks/UseBuildings/useBuildingRefsHook"
import { BoxArrowUpRight } from "react-bootstrap-icons"

export default function BuildingAmenityEntry(props: {
    buildingAmenityData: BuildingAmenityType,
    fullView?: boolean,
    showActions?: boolean,
}) {

    const {
        buildingAmenityData,
        fullView: initialFullView = false,
        showActions = true,
    } = props

    const [fullView, setFullView] = useState(initialFullView)
    const amenityRefs = useAmenityRefs()
    const buildingRefs = useBuildingRefs()

    const {
        _id,
        buildingId,
        amenityId,
        overrides,
    } = buildingAmenityData

    const amenityData = amenityRefs[amenityId]
    const amenityName = amenityData?.title || amenityId
    const buildingData = buildingRefs[buildingId]
    const buildingName = buildingData?.title || `Building ${buildingId}`

    return (
        <Card className="mb-3">
            <Card.Body>
                <Card.Title>
                    {amenityName}
                    {canAccess('routes', 'amenity') && amenityData?._id && (
                        <Link to={`/amenity/${amenityData._id}`} className="ms-2 small">
                            <BoxArrowUpRight size={16} viewBox={'0 0 20 20'} />
                        </Link>
                    )}
                </Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                    {buildingName}
                    {canAccess('routes', 'building') && buildingData?._id && (
                        <Link to={`/building/${buildingData._id}`} className="ms-2 small">
                            <BoxArrowUpRight size={16} viewBox={'0 0 20 20'} />
                        </Link>
                    )}
                </Card.Subtitle>

                {fullView && (
                    <>
                        <hr />
                        <Card.Text className="mb-1 small">
                            <strong>Building ID:</strong> {buildingId}
                        </Card.Text>
                        <Card.Text className="mb-1 small">
                            <strong>Amenity ID:</strong> {amenityId}
                        </Card.Text>
                        {overrides && Object.keys(overrides).length > 0 && (
                            <Card.Text className="mb-1 small">
                                <strong>Overrides:</strong>
                                <pre className="mt-1">{JSON.stringify(overrides, null, 2)}</pre>
                            </Card.Text>
                        )}
                    </>
                )}

            </Card.Body>

            {showActions && (
                <Card.Footer>
                    {!initialFullView && canAccess('routes', 'building-amenity') && (
                        <Link className="btn btn-primary btn-sm me-2 mb-2" to={`/building-amenity/${_id}`}>
                            View
                        </Link>
                    )}
                    {canAccess('routes', 'edit-building-amenity') && (
                        <Link className="btn btn-secondary btn-sm me-2 mb-2" to={`/edit-building-amenity/${_id}`}>
                            Edit
                        </Link>
                    )}
                    {canAccess('routes', 'delete-building-amenity') && (
                        <Link className="btn btn-danger btn-sm me-2 mb-2" to={`/delete-building-amenity/${_id}`}>
                            Delete
                        </Link>
                    )}
                    {!initialFullView && (
                        <Button
                            className="me-2 mb-2"
                            variant="secondary"
                            size="sm"
                            onClick={() => setFullView(!fullView)}
                        >
                            {fullView ? 'Hide Details' : 'Show Details'}
                        </Button>
                    )}
                </Card.Footer>
            )}
        </Card>
    )
}
